// Code review - In Progress
// Documentation - In Progress
import { useEffect } from "react";
import { mainTable } from "../css/Common";
import { useState } from "react";
import { areaMasterHeader } from "../components/HeaderAttribute";
import MainLayout from "../components/MainLayout";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import MainPopup from "../popup-containers/MainPopup";
import AreaPopupmaster from "../popup-containers/AreaPopupmaster";
import toast from "react-hot-toast";
import Loader from "../ReusableComponents/Loader";
import * as XLSX from "sheetjs-style";
import {
  BindAPI,
  BindPostAPI,
  IUDAPI,
  LanguageTranslatorAPI,
} from "../services/APIConnection";
import GridPage from "../components/GridPage";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import Buttons from "../components/Buttons";
import AddScreenTitle from "../components/AddScreenTitle";
import { useLocation } from "react-router-dom";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import { useUserCapability } from "../components/ConstantReducerProvider";

const AreaMaster = () => {
  const location1 = useLocation();

  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [bindAreaMasterDatas, setbindAreaMasterDatas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [location, setLocation] = useState("");
  const [areaName, setAreaName] = useState("");
  const [areaCode, setAreaCode] = useState("");
  const [sdp, setSDP] = useState("");
  const [mstAreaId, setMstAreaId] = useState("");
  const createdBy = sessionStorage.getItem("createdBy");

  const [stateError, setStateError] = useState(""); // Will be Used In Functionality
  const [locationError, setLocationError] = useState("");
  const [sdpError, setSDPError] = useState("");
  const [areaNameError, setAreaNameError] = useState("");
  const [areaCodeError, setAreaCodeError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [email, setEmail] = useState("");
  const [visibleAddScreen, setvisibleAddScreen] = useState(false);
  const [visibleEditScreen, setvisibleEditScreen] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  // View details start

  const [popUpOpen, setpopUpOpen] = useState(false);
  const [rowIndex, setRowIndex] = useState("");
  const [AreaMasterData, setAreaMasterData] = useState("");
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);

  // view details end

  const [editMode, setEditMode] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);

  const [bindState, setBindStatesDD] = useState([]);
  const [bindLocation, setBindLocationDD] = useState([]);

  const [bindSDP, setBindSDP] = useState([]);

  const [languageCodeKey, setLanguageCodekey] = useState([]);
  const [languageGetCode, setLanguageGetCode] = useState([]);

  const [popupdata1, setPopupdata1] = useState({});

  const [getLocationDatas, setGetLocationDatas] = useState([]);
  const [getSDPDatas, setGetSDPDatas] = useState([]);

  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setvisibleAddScreen(true); // Add Screen title & button
    setvisibleEditScreen(false); // Update Screen title & button
    const profile = userProfileDatas?.[0];

    if (profile) {
      if (profile?.MstStateId) {
        setState(profile.MstStateId);
        dropdownstate1(profile.MstStateId);
      }

      if (profile?.MstLocationId) {
        setLocation(profile.MstLocationId);
        dropdownlocation1(profile.MstLocationId);
      }

      if (profile?.MstSDPId) {
        setSDP(profile.MstSDPId);
        dropdownsdp1(profile.MstSDPId);
      }
    }
  };

  const dropdownValuesEffect = () => {
    if (editMode && selectedRowIndex !== null) {
      dropdownstate(selectedRowIndex);
      dropdownlocation(selectedRowIndex);
      dropdownsdp(selectedRowIndex);
    }
  };

  const dropdownstate = (rowIndex) => {
    try {
      const StaterowData = bindAreaMasterDatas[rowIndex];
      const StateInfo = bindState.find(
        (ST) => ST.value === StaterowData.MstStateId,
      );

      const resultState = {
        value: StaterowData.MstStateId,
        label: StateInfo ? StateInfo.label : "DefaultStateLabel",
      };

      setState(resultState);
    } catch (error) {
      console.error("Error setting state:", error);
    }
  };
  const dropdownstate1 = (rowIndex) => {
    try {
      const StaterowData = userProfileDatas[0]?.MstStateId;
      const StateInfo = bindState.find((ST) => ST.value === StaterowData);

      const resultState = {
        value: StaterowData,
        label: StateInfo ? StateInfo.label : "DefaultStateLabel",
      };

      setState(resultState);
    } catch (error) {
      console.error("Error setting state:", error);
    }
  };

  const dropdownlocation1 = (rowIndex) => {
    try {
      const locationrowData = userProfileDatas[0]?.MstLocationId;
      const LocationInfo = getLocationDatas.find(
        (L) => L.MstLocationId === locationrowData,
      );
      const ResultLocation = {
        value: locationrowData,
        label: LocationInfo
          ? LocationInfo.LocationName_en
          : "DefaultStateLabel",
      };
      setLocation(ResultLocation);
    } catch (error) {
      console.error("Error setting state:", error);
    }
  };

  const dropdownsdp = (rowIndex) => {
    try {
      const SDProwData = bindAreaMasterDatas[rowIndex];
      const SDPInfo = getSDPDatas.find(
        (SD) => SD.MstSDPId === SDProwData.MstSDPId,
      );
      const ResultSDP = {
        value: SDProwData.MstSDPId,
        label: SDPInfo ? SDPInfo.SDP_en : "DefaultStateLabel",
      };
      setSDP(ResultSDP);
    } catch (error) {
      console.error("Error setting state:", error);
    }
  };
  const dropdownsdp1 = (rowIndex) => {
    try {
      const SDProwData = userProfileDatas[0]?.MstSDPId;
      const SDPInfo = getSDPDatas.find((SD) => SD.MstSDPId === SDProwData);
      const ResultSDP = {
        value: SDProwData,
        label: SDPInfo ? SDPInfo.SDP_en : "DefaultStateLabel",
      };
      setSDP(ResultSDP);
    } catch (error) {
      console.error("Error setting state:", error);
    }
  };
  const dropdownlocation = (rowIndex) => {
    try {
      const locationrowData = bindAreaMasterDatas[rowIndex];
      const LocationInfo = getLocationDatas.find(
        (L) => L.MstLocationId === locationrowData.MstLocationId,
      );
      const ResultLocation = {
        value: locationrowData.MstLocationId,
        label: LocationInfo
          ? LocationInfo.LocationName_en
          : "DefaultStateLabel",
      };
      setLocation(ResultLocation);
    } catch (error) {
      console.error("Error setting state:", error);
    }
  };

  useEffect(dropdownValuesEffect, [editMode, selectedRowIndex]);

  const handleEdit = (rowIndex) => {
    // Edit Functionality

    setEditMode(true);
    setSelectedRowIndex(rowIndex);

    setVisibleAdd(true);
    setVisibleTable(false);
    setvisibleAddScreen(false);
    setvisibleEditScreen(true);

    setSDP(bindAreaMasterDatas[rowIndex].SdpName);
    setAreaName(bindAreaMasterDatas[rowIndex].AreaName_en);
    setAreaCode(bindAreaMasterDatas[rowIndex].AreaCode);
    setCountry(bindAreaMasterDatas[rowIndex].CountryName);
    setMstAreaId(bindAreaMasterDatas[rowIndex].MstAreaId);
    setEmail(bindAreaMasterDatas[rowIndex].AreaEmail);
    setState(bindAreaMasterDatas[rowIndex].MstStateId);
    setLocation(bindAreaMasterDatas[rowIndex].MstLocationId);
    setSDP(bindAreaMasterDatas[rowIndex].MstSDPId);
  };

  const handleArea = (rowIndex, flag) => {
    // Setting visibility in popup container
    handleOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }
    setAreaMasterData(bindAreaMasterDatas[rowIndex]);

    const StaterowData = bindAreaMasterDatas[rowIndex];
    const StateInfo = bindState.find(
      (ST) => ST.value === StaterowData.MstStateId,
    );

    const resultState = {
      value: StaterowData.MstStateId,
      label: StateInfo ? StateInfo.label : "DefaultStateLabel",
    };

    const locationrowData = bindAreaMasterDatas[rowIndex];
    const LocationInfo = getLocationDatas.find(
      (L) => L.MstLocationId === locationrowData.MstLocationId,
    );
    const ResultLocation = {
      value: locationrowData.MstLocationId,
      label: LocationInfo ? LocationInfo.LocationName_en : "DefaultStateLabel",
    };

    const SDProwData = bindAreaMasterDatas[rowIndex];
    const SDPInfo = getSDPDatas.find(
      (SD) => SD.MstSDPId === SDProwData.MstSDPId,
    );
    const ResultSDP = {
      value: SDProwData.MstSDPId,
      label: SDPInfo ? SDPInfo.SDP_en : "DefaultStateLabel",
    };

    const AutoDropdownPopupdata = [resultState, ResultLocation, ResultSDP];
    setPopupdata1(AutoDropdownPopupdata);
  };

  useEffect(() => {
    // Language Translator
    const getLanguageCode = async () => {
      const response = await BindAPI("LanguageAPI/GetLanguage");
      setLanguageCodekey(response.data.Table);
    };
    getLanguageCode();
  }, []);

  useEffect(() => {
    // Language Translator
    var languageKeys = languageCodeKey.map((item) => item.LanguageKey);
    setLanguageGetCode(languageKeys);
  }, [languageCodeKey]);

  const validateEmail = (value) => {
    const trimmedEmail = value.trim();

    if (!trimmedEmail) {
      return "";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return emailRegex.test(trimmedEmail)
      ? ""
      : "Enter a valid Email Id";
  };

  const handleSubmit = async (items, flag) => {
    // Submit functionality
    setSubmitBtnDisabled(true);
    setIsLoading(true);
    if (flag == 1 || flag == 2) {
      // validation start
      let stateValidate = "";
      let locationValidate = "";
      let sdpValidate = "";
      let areaNameValidate = "";
      let areaCodeValidate = "";
      let emailValidate = "";

      stateValidate = state ? "" : "Select State Name";
      setStateError(stateValidate);

      locationValidate = location ? "" : "Select Branch/Project Name";
      setLocationError(locationValidate);

      sdpValidate = sdp ? "" : "Select S.D.P Name";
      setSDPError(sdpValidate);

      // areaNameValidate =
      //   areaName.length > 0
      //     ? /^[A-Za-z !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/.test(areaName)
      //       ? !editMode &&
      //         bindAreaMasterDatas && // Ensure bindAreaMasterDatas is not null
      //         bindAreaMasterDatas.find(
      //           (x) =>
      //             x.AreaName_en &&
      //             x.AreaName_en.toLowerCase() == areaName.toLowerCase(),
      //         )
      //         ? "Area Name already available"
      //         : ""
      //       : "Only Alphabet and space allowed"
      //     : "Enter Area Name";
      areaNameValidate =
  areaName.length > 0
    ? /^[A-Za-z !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/.test(areaName)
      ? bindAreaMasterDatas?.find(
          (x) =>
            x.AreaName_en &&
            x.AreaName_en.trim().toLowerCase() ===
              areaName.trim().toLowerCase() &&
            x.MstLocationId === location?.value &&
            x.MstSDPId === sdp?.value &&
            x.MstAreaId !== mstAreaId
        )
        ? "Same Area already available for this Branch/Project and S.D.P."
        : ""
      : "Only Alphabet and space allowed"
    : "Enter Area Name";

      // areaCodeValidate =
      //   areaCode.length > 0
      //     ? /^[A-Z0-9]{3,4}$/.test(areaCode)
      //       ? !editMode &&
      //         bindAreaMasterDatas && // Ensure bindAreaMasterDatas is not null
      //         bindAreaMasterDatas.find(
      //           (x) =>
      //             x.AreaCode &&
      //             x.AreaCode.toLowerCase() == areaCode.toLowerCase(),
      //         )
      //         ? "Area Code already available"
      //         : ""
      //       : "Area Code must be atleast 3 uppercase letters"
      //     : "Enter Area Code";

          areaCodeValidate =
        areaCode.length > 0
          ? /^[A-Z0-9]{3,4}$/.test(areaCode)
            ?  ""
            : "Area Code must be atleast 3 uppercase letters"
          : "Enter Area Code";

      emailValidate = validateEmail(email);

      setAreaNameError(areaNameValidate);
      setAreaCodeError(areaCodeValidate);
      setEmailError(emailValidate);

      if (
        stateValidate ||
        locationValidate ||
        sdpValidate ||
        areaNameValidate ||
        areaCodeValidate ||
        emailValidate
      ) {
        setIsOpen(true);
      }

      if (
        !stateValidate &&
        !locationValidate &&
        !sdpValidate &&
        !areaNameValidate &&
        !areaCodeValidate
        &&
        !emailValidate
      ) {
        // const languageKeys = [
        //   "ta", // Tamil
        //   "hi", // Hindi
        //   "mr", // Marathi
        //   "gu", // Gujarati
        //   "kn", // Kannada
        //   "ml", // Malayalam
        //   "te", // Telugu
        //   "bn", // Bengali
        //   "or", // Oriya
        // ];

        // const translatedTexts = []; // Create an array to store translations

        // for (let i of languageKeys) {
        //   const translateText = await LanguageTranslatorAPI(areaName, i);
        //   translatedTexts.push(
        //     translateText.data.data.translations[0].translatedText
        //   );
        // }
        setIsOpen(false);
        const data = [
          {
            mstAreaId: mstAreaId ? mstAreaId : 0,
            areaCode: areaCode,
            mstCountryId: 1,
            mstStateId: state.value,
            mstLocationId: location.value,
            mstSDPId: sdp.value,
            areaNameEn: areaName,
            areaNameTa: areaName,
            areaNameHi: areaName,
            areaNameMr: areaName,
            areaNameGu: areaName,
            areaNameKn: areaName,
            areaNameMl: areaName,
            areaNameTe: areaName,
            areaNameBn: areaName,
            areaNameOr: areaName,
            areaEmail: email,
            createdBy: createdBy,
            flag: flag,
          },
        ];
        const response = await IUDAPI(data, "AreaAPI/IUDArea");
        if (flag == 1) {
          // Submit

          if (response.data.Table[0].Result === "S") {
            toast.success("Area data added successfully 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to add Area data 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        } else if (flag == 2) {
          // Update
          if (response.data.Table[0].Result === "M") {
            toast.success("Area data updated successfully 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to update Area data 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        }
      } else {
        setSubmitBtnDisabled(false);
        setIsLoading(false);
      }
    } else {
      const data = [
        {
          mstAreaId: bindAreaMasterDatas[rowIndex].MstAreaId,
          createdBy: createdBy,
          flag: flag,
        },
      ];
      const response = await IUDAPI(data, "AreaAPI/IUDArea");
      if (flag == 3) {
        // Delete
        if (response.data.Table[0].Result === "D") {
          toast.success("Area data deleted successfully 👍", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
        else if (response.data.Table[0].Result === "P") {
          toast.error("Area cannot be deleted because it is being used.👎", {
            duration: 1000,
            position: "top-center",
          });

          setTimeout(cancel, 2000);
        } else {
          toast.error("Failed to delete Area data 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      } else if (flag == 4) {
        // Block
        if (response.data.Table[0].Result === "B") {
          toast.success("Area data blocked successfully 🚫", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.error("Failed to block Area data 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      } else if (flag == 5) {
        // Unblock
        if (response.data.Table[0].Result === "UB") {
          toast.success("Area data unblocked successfully ✅", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.error("Failed to unblock Area data 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      }
    }
  };

  const areaMasterHeader2 = [
    { title: "S.No", field: "SNo" },
    { title: "MstAreaId", field: "MstAreaId" },
    { title: "Country", field: "CountryName_en" },
    { title: "State", field: "StateName_en" },
    { title: "Branch / Project", field: "LocationName_en" },
    { title: "SDP", field: "SDP_en" },
    { title: "Area_en", field: "AreaName_en" },
    { title: "Area_ta", field: "AreaName_ta" },
    { title: "Area_hi", field: "AreaName_hi" },
    { title: "Area_mr", field: "AreaName_mr" },
    { title: "Area_gu", field: "AreaName_gu" },

    { title: "Area_kn", field: "AreaName_kn" },
    { title: "Area_ml", field: "AreaName_ml" },

    { title: "Area_te", field: "AreaName_te" },
    { title: "Area_bn", field: "AreaName_bn" },
    { title: "Area_or", field: "AreaName_or" },
    { title: "Area Code", field: "AreaCode" },
    { title: "Email", field: "AreaEmail" },
    { title: "Created By", field: "CreatedByName" }, // ✅
  ];

  const handleExport = async () => {
    const createdBy = sessionStorage.getItem("createdBy");

    try {
      const areaResponse = await BindAPI("AreaAPI/BindAreaExcel");
      const rows = areaResponse?.data?.Table || [];

      if (rows.length === 0) {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "AREA MASTER",
            action: "EXCEL EXPORT",
            status: "FAILED",
            tableName: "mst_area",
            description: "No data available to export",
          },
          "Log/IUDLog",
        );

        toast.error("No data available to export", {
          duration: 1000,
          position: "top-center",
        });

        return;
      } else {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "AREA MASTER",
            action: "EXCEL EXPORT",
            status: "SUCCESS",
            tableName: "mst_area",
            description: `Area Excel exported successfully. Total Records: ${rows.length}`,
          },
          "Log/IUDLog",
        );
      }
      // exportAreaData(areaMasterHeader2, rows);
    } catch (error) {
      console.error("Export Error:", error);

      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "AREA MASTER",
          action: "EXCEL EXPORT",
          status: "FAILED",
          tableName: "mst_area",
          description: error?.message || "Excel export failed",
        },
        "Log/IUDLog",
      );

      toast.error("Failed to export Excel 👎", {
        duration: 1000,
        position: "top-center",
      });
    }
    try {
      const areaResponse = await BindAPI("AreaAPI/BindAreaExcel");
      const userProfileDatas = userProfileState?.userProfile || [];
      const locationId = userProfileDatas[0]?.MstLocationId;
      const orgStructureId = userProfileDatas[0]?.MstOrganizationId;

      let rows = []; // ✅ changed to let

      const tableData = areaResponse?.data?.Table || [];

      if (orgStructureId === 1) {
        rows = tableData;
      } else {
        rows = tableData.filter((item) => item?.MstLocationId === locationId);
      }
      if (rows.length === 0) {
        toast.error("No data available to export", {
          duration: 1000,
          position: "top-center",
        });
        return;
      }

      // ✅ pass only string headers
      exportAreaData(
        areaMasterHeader2.map((col) => col.title),
        rows,
      );
    } catch (error) {
      console.error("Area Excel Export Error:", error);
      toast.error("Failed to export Area data", {
        duration: 1000,
        position: "top-center",
      });
    }
  };
  const exportAreaData = (columns, rows) => {
    /* ================= TITLE ================= */
    const titleRow = [
      {
        v: "Area Master",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    /* ================= HEADER ================= */
    const headerRow = columns.map((column) => ({
      v: column,
      s: {
        fill: { fgColor: { rgb: "2D2D6E" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left" },
      },
    }));

    const spacingRow = [{ v: "" }];

    /* ================= DATA ROWS ================= */
    const dataRows = rows.map((row, index) => {
      const isAlt = index % 2 === 1;
      const style = isAlt ? { fill: { fgColor: { rgb: "F0F0F0" } } } : {};

      return [
        { v: index + 1, s: style }, // S.No
        { v: row.MstAreaId, s: style }, // Country
        { v: row.CountryName_en, s: style }, // Country
        { v: row.StateName_en, s: style }, // State
        { v: row.LocationName_en, s: style }, // Branch / Project
        { v: row.SDP_en, s: style }, // SDP
        { v: row.AreaName_en, s: style }, // Area
        { v: row.AreaName_ta, s: style }, // Area
        { v: row.AreaName_hi, s: style }, // Area
        { v: row.AreaName_mr, s: style }, // Area
        { v: row.AreaName_gu, s: style }, // Area

        { v: row.AreaName_kn, s: style }, // Area
        { v: row.AreaName_ml, s: style }, // Area

        { v: row.AreaName_te, s: style }, // Area
        { v: row.AreaName_bn, s: style }, // Area
        { v: row.AreaName_or, s: style }, // Area
        { v: row.AreaCode, s: style }, // Area Code
        { v: row.AreaEmail, s: style }, // Email
        { v: row.CreatedByName, s: style }, // Created By
      ];
    });

    /* ================= SHEET DATA ================= */
    const wsData = [titleRow, spacingRow, headerRow, ...dataRows];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    /* ================= COLUMN WIDTH ================= */
    ws["!cols"] = [
      { width: 5 }, // S.No
      { width: 20 }, // Country
      { width: 20 }, // Country
      { width: 20 }, // State
      { width: 30 }, // Branch
      { width: 30 }, // SDP
      { width: 30 }, // Area
      { width: 30 }, // Area
      { width: 30 }, // Area
      { width: 30 }, // Area
      { width: 30 }, // Area
      { width: 30 }, // Area
      { width: 30 }, // Area
      { width: 30 }, // Area
      { width: 30 }, // Area
      { width: 30 }, // Area
      { width: 15 }, // Area Code
      { width: 35 }, // Email
      { width: 30 }, // Created By
    ];

    /* ================= ROW HEIGHT ================= */
    ws["!rows"] = [
      { hpt: 30 },
      { hpt: 15 },
      { hpt: 18 },
      ...Array(rows.length).fill({ hpt: 15 }),
    ];

    /* ================= BORDERS ================= */
    const applyStyles = (worksheet) => {
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!worksheet[cellRef]) continue;

          worksheet[cellRef].s = {
            ...worksheet[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    /* ================= EXPORT ================= */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Area Master");
    XLSX.writeFile(wb, "Area_Master.xlsx");

    toast.success("Excel exported successfully 👍", {
      duration: 1000,
      position: "top-center",
    });
  };
  const cancel = () => {
    setEditMode(false);
    setSelectedRowIndex(null);
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    setvisibleAddScreen(false);
    setvisibleEditScreen(false);
    setSubmitBtnDisabled(false);
    // Clear Area data
    setAreaName("");
    setAreaCode("");
    setState("");
    setLocation("");
    setSDP("");
    setAreaNameError("");
    setAreaCodeError("");
    setStateError("");
    setLocationError("");
    setEmailError("");
    setEmail("");
    setSDPError("");
    areaMasterData();
    setIsLoading(false);
  };

  // Common filter function
  const filterBlocked = (data) =>
    data.filter((item) => item.BlockedBy === null);

  useEffect(() => {
    areaMasterData();
  }, []);
  const areaMasterData = async () => {
    const [profile] = userProfileDatas;
    try {
      setIsLoading(true);
      const data = {
        mstOrganizationStructureId: profile.MstOrganizationId,
        mstBranchId: profile.MstLocationId,
        mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
        mstUserId: profile.MstUserId,
        mstRoleId: profile.MstRoleId,
        languageCode: "en",
      };
      // Run all API calls in parallel
      const [areaRes, masterRes, locationRes, sdpRes] = await Promise.all([
        BindAPI("AreaAPI/BindArea"),
        BindAPI("ClientAPI/BindClientAllMasterDatas"),
        BindPostAPI([data], "LocationAPI/GetLocation"),
        BindPostAPI([data], "SDPAPI/GetSDP"),
      ]);

      // ✅ Area Data
      const locationId = userProfileDatas?.[0]?.MstLocationId;

      const allAreas = areaRes?.data?.Table || [];

      const filteredAreas = locationId
        ? allAreas.filter((item) => item.MstLocationId === locationId)
        : allAreas; // If no locationId → show all data

      setbindAreaMasterDatas(filteredAreas);

      // ✅ State Data
      const stateData = filterBlocked(masterRes?.data?.Table7 || []).map(
        (m) => ({
          value: m.MstStateId,
          label: m.StateName_en,
        }),
      );
      setBindStatesDD(stateData);

      // ✅ Location Data
      setGetLocationDatas(filterBlocked(locationRes?.data?.Table || []));

      // ✅ SDP Data
      setGetSDPDatas(filterBlocked(sdpRes?.data?.Table || []));
    } catch (error) {
      console.error("Error fetching master data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    const stateSelectedValue = getLocationDatas.find(
      (item) => item.MstStateId == state.value,
    );

    if (stateSelectedValue) {
      const locationLabels = getLocationDatas
        .filter((item) => item.MstStateId === stateSelectedValue.MstStateId)
        .map((item) => ({
          MstLocationId: item.MstLocationId,
          LocationName_en: item.LocationName_en,
        }));

      const locationSelected = locationLabels.map((LC) => ({
        value: LC.MstLocationId,
        label: LC.LocationName_en,
      }));
      setBindLocationDD(locationSelected);
    } else {
      console.log("stateSelectedValue is undefined or not found.");
    }
  }, [state]);

  useEffect(() => {
    const SDPSelectedValue = getSDPDatas.find(
      (item) => item.MstLocationId == location.value,
    );

    if (SDPSelectedValue) {
      const sdpLabels = getSDPDatas
        .filter((item) => item.MstLocationId === SDPSelectedValue.MstLocationId)
        .map((item) => ({ MstSDPId: item.MstSDPId, SDP_en: item.SDP_en }));

      const sdpSelected = sdpLabels.map((SD) => ({
        value: SD.MstSDPId,
        label: SD.SDP_en,
      }));
      setBindSDP(sdpSelected);
    } else {
      console.log("stateSelectedValue is undefined or not found.");
    }
  }, [location]);
  useEffect(() => {
    if (location1.pathname == "/areamaster") {
      setVisibleTable(true);
      setVisibleAdd(false);
      areaMasterData();
    }
  }, [location1]);

  return (
    <MainLayout pageName="2">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title={"Area Master"}
          header={areaMasterHeader}
          records={bindAreaMasterDatas}
          handleEdit={handleEdit}
          handleExportBtn={true}
          handleExport={handleExport}
          handleAction={handleArea}
          showAdd={showAdd}
          blockView={true}
        />
      )}
      {visibleAdd && (
        <div class="w-full ">
          <div class=" border-black  ">
            <AddScreenTitle
              addScreenTitle={visibleAddScreen}
              updateScreenTitle={visibleEditScreen}
              title="Area Master"
            />
          </div>

          <div className={mainTable.addShadowScreen}>
            <div className={mainTable.mainContentScreen}>
              <form className={mainTable.formForClientMaster}>
                <div className={mainTable.grid3}>
                  <DropDown
                    classStar="text-red-500"
                    classDiv="hidden"
                    title="Country"
                    options={[]}
                    placeholder="Select"
                    tabIndex="0"
                    name="country"
                    selectedOption={country}
                    controlFunc={(e) => setCountry(e.target.value)}
                  />
                  <div>
                    <AutoDropDown
                      classStar="text-red-500"
                      title="State"
                      options={bindState}
                      placeholder="Select"
                      name="state"
                      disabled={userProfileDatas?.[0]?.MstOrganizationId != 1 ? true : false }
                      selectedOption={state}
                      controlFunc={(value) => {
                        setLocation("");
                        setSDP("");
                        setState(value);
                        setStateError(value ? "" : "Select State Name");
                      }}
                      controlFuncBlur={() => {
                        setStateError(state ? "" : "Select State Name");
                      }}
                      Class="custom-class"
                      tabIndex="0"
                    />
                    {stateError && (
                      <span class="text-red-500">{stateError}</span>
                    )}
                  </div>
                  <div>
                    <AutoDropDown
                      classStar="text-red-500"
                      title={"Branch/Project"}
                      options={bindLocation}
                      placeholder={"Select"}
                      name={"location"}
                      selectedOption={location}
                      controlFunc={(value) => {
                        setLocation(value);
                        setLocationError(
                          value ? "" : "Select Branch/Project Name",
                        );
                        setSDP("");
                      }}
                      controlFuncBlur={() => {
                        setLocationError(
                          location ? "" : "Select Branch/Project Name",
                        );
                      }}
                      Class="custom-class"
                      tabIndex="0"
                    />
                    {locationError && (
                      <span class="text-red-500">{locationError}</span>
                    )}
                  </div>
                  <div>
                    <AutoDropDown
                      classStar="text-red-500"
                      title={"S.D.P."}
                      options={bindSDP}
                      placeholder={"Select"}
                      name={"sdp"}
                      selectedOption={sdp}
                      controlFunc={(value) => {
                        setSDP(value);
                        setSDPError(value ? "" : "Select S.D.P Name");
                      }}
                      controlFuncBlur={() => {
                        setSDPError(sdp ? "" : "Select S.D.P Name");
                      }}
                      Class="custom-class"
                      tabIndex="0"
                    />
                    {sdpError && <span class="text-red-500">{sdpError}</span>}
                  </div>
                  <div>
                    <InputText
                      classStar="text-red-500"
                      inputType={"text"}
                      title={"Area"}
                      tabIndex="0"
                      name={"area"}
                      maxLength={200}
                      content={areaName}
                      controlFunc={(e) => setAreaName(e.target.value)}
                      // controlFuncBlur={(e) => {
                      //   const trimmedValue = e.target.value.trim();
                      //   setAreaName(trimmedValue);
                      //   setAreaNameError(
                      //     trimmedValue.length > 0
                      //       ? /^[A-Za-z !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/.test(
                      //         trimmedValue,
                      //       )
                      //         ? !editMode &&
                      //           bindAreaMasterDatas.find(
                      //             (x) =>
                      //               x.AreaName_en.toLowerCase() ==
                      //               trimmedValue.toLowerCase(),
                      //           )
                      //           ? "Area Name already available"
                      //           : ""
                      //         : "Only Alphabet and space allowed"
                      //       : "Enter Area Name",
                      //   );
                      // }}
                      controlFuncBlur={(e) => {
                        const trimmedValue = e.target.value.trim();
                      
                        setAreaName(trimmedValue);
                      
                        const duplicateArea = bindAreaMasterDatas?.find(
                          (x) =>
                            x.AreaName_en &&
                            x.AreaName_en.trim().toLowerCase() ===
                              trimmedValue.toLowerCase() &&
                            x.MstLocationId === location?.value &&
                            x.MstSDPId === sdp?.value &&
                            x.MstAreaId !== mstAreaId
                        );
                      
                        setAreaNameError(
                          trimmedValue.length === 0
                            ? "Enter Area Name"
                            : !/^[A-Za-z !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/.test(
                                trimmedValue
                              )
                            ? "Only Alphabet and space allowed"
                            : duplicateArea
                            ? "Same Area already available for this Branch/Project and S.D.P."
                            : ""
                        );
                      }}
                    />
                    {areaNameError && (
                      <span class="text-red-500">{areaNameError}</span>
                    )}
                  </div>
                  <div>
                    <InputText
                      classStar="text-red-500"
                      inputType={"text"}
                      tabIndex="0"
                      title={"Area Code"}
                      name={"area"}
                      maxLength={4}
                      content={areaCode}
                      controlFunc={(e) => setAreaCode(e.target.value)}
                      disabled={editMode ? editMode : false}
                      controlFuncBlur={(e) => {
                        setAreaCode(e.target.value);
                        setAreaCodeError(
                          // areaCode.length > 0
                          //   ? /^[A-Z0-9]{3,4}$/.test(areaCode)
                          //     ? !editMode &&
                          //       bindAreaMasterDatas && // Ensure bindAreaMasterDatas is not null
                          //       bindAreaMasterDatas.find(
                          //         (x) =>
                          //           x.AreaCode &&
                          //           x.AreaCode.toLowerCase() ===
                          //           areaCode.toLowerCase(),
                          //       )
                          //       ? "Area Code already available"
                          //       : ""
                          //     : "Area Code must be atleast 3 uppercase letters"
                          //   : "Enter Area Code",

                            areaCode.length > 0
                            ? /^[A-Z0-9]{3,4}$/.test(areaCode)
                              ?  ""
                              : "Area Code must be atleast 3 uppercase letters"
                            : "Enter Area Code",
                        );
                      }}
                    />
                    {areaCodeError && (
                      <span class="text-red-500">{areaCodeError}</span>
                    )}
                  </div>
                  <div>
                    <InputText
                      inputType={"text"}
                      title={"Email Id"}
                      maxLength={200}
                      tabIndex='0'
                      name={"area"}
                      content={email}
                      // controlFunc={(e) => setEmail(e.target.value)}
                      controlFunc={(e) => { setEmail(e.target.value); setEmailError(validateEmail(e.target.value)); }} controlFuncBlur={(e) => { const trimmedEmail = e.target.value.trim(); setEmail(trimmedEmail); setEmailError(validateEmail(trimmedEmail)); }}
                    />
                    {emailError && (
                      <span class="text-red-500">{emailError}</span>
                    )}
                  </div>
                </div>
                <Buttons
                addScreenTitle={visibleAddScreen}
                updateScreenTitle={visibleEditScreen}
                handleSubmit={handleSubmit}
                cancel={cancel}
                disabledBtn={submitBtnDisabled ? true : false}
              />
              </form>

           
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleArea}
      >
        <div>
          <PopUpScreenTitle
            title="Area Master"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />

          <AreaPopupmaster data={AreaMasterData} data1={popupdata1} />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};
export default AreaMaster;
